import React from 'react';
import { IconProps } from '../types';
const MinecraftSeagrass: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="4" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="1" y="11" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(41, 113, 0, 255)" />
<rect x="14" y="11" width="1" height="1" fill="rgba(41, 113, 0, 255)" />
<rect x="0" y="12" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(41, 113, 0, 255)" />
<rect x="14" y="12" width="1" height="1" fill="rgba(80, 149, 41, 255)" />
<rect x="0" y="13" width="1" height="1" fill="rgba(41, 113, 0, 255)" />
<rect x="1" y="13" width="1" height="1" fill="rgba(41, 113, 0, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="13" y="13" width="1" height="1" fill="rgba(41, 113, 0, 255)" />
<rect x="14" y="13" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="1" y="14" width="1" height="1" fill="rgba(41, 113, 0, 255)" />
<rect x="2" y="14" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="12" y="14" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="13" y="14" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="14" y="14" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="1" y="15" width="1" height="1" fill="rgba(41, 113, 0, 255)" />
<rect x="2" y="15" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="3" y="15" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="4" y="15" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="5" y="15" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
<rect x="6" y="15" width="1" height="1" fill="rgba(56, 147, 6, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="9" y="15" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="11" y="15" width="1" height="1" fill="rgba(33, 88, 0, 255)" />
<rect x="12" y="15" width="1" height="1" fill="rgba(41, 113, 0, 255)" />
<rect x="13" y="15" width="1" height="1" fill="rgba(41, 113, 0, 255)" />
<rect x="14" y="15" width="1" height="1" fill="rgba(47, 130, 0, 255)" />
</svg>);
export default MinecraftSeagrass;